import { RESTSerializer } from '@warp-drive/legacy/serializer/rest';

export default class ApplicationSerializer extends RESTSerializer {
  moveRelationship(key, source, target) {
    target[key] = source[key];
    delete source[key];
  }
}
